"use strict";
import helpers from "./_helpers";

const Companies = () => {
    const init = () => {
        $(document).ready(function() {
            let el = document.getElementById('companies');
            if (el) {
                let $form = $(el),
                  $brand = $form.find('#brand'),
                  $dataContainer = $('#companies-list');

                $brand.change(function() {
                    let val = $(this).val();
                    // Update value
                    $("input[name='brand']").val(val);

                    // Submit form to trigger ajax
                    $form.submit();

                    // Update visual states
                    $brand.find('a.active').removeClass('active');
                    $form.find("a[data-brand='" + val + "']").addClass('active');

                    if (val === "all") {
                        $brand.parents('.form-group').removeClass('filled');
                        $brand.parents('.form-group').removeClass('focused');
                        helpers.deleteUrlParameter('brand');
                    } else {
                        helpers.setUrlParameter('brand', val);
                    }
                });

                $dataContainer.addClass('loaded');
            }
        });
    };

    return {
        init:init
    };
};

export default Companies;